import { render, staticRenderFns } from "./NeartoSlider.vue?vue&type=template&id=823b000c&"
import script from "./NeartoSlider.vue?vue&type=script&lang=js&"
export * from "./NeartoSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports